// CUSTOM JavaScript
import './jquery-global.js';
import AOS from 'aos';
import '../../node_modules/bootstrap/dist/js/bootstrap.bundle';
import './fontawesome/fontawesome.min';
import './fontawesome/light.min';
import './fontawesome/brands.min';
import './ekko-lightbox.min.js';

// Lightbox


$(document).on("click", '[data-toggle="lightbox"]', function(event) {
    event.preventDefault();
    $(this).ekkoLightbox({
        'showArrows':false,
        'alwaysShowClose': true
    });
});

if ($('body').hasClass('home-page') || $('fixed-backgrounds-component').hasClass()) {
    let activeSectionId = '';
    if ($('.home-section-fixed.active')[0])  {
        activeSectionId = $('.home-section-fixed.active')[0].id
    }

    $('.home-section-fixed.active').fadeIn();

    $('#menuToggle').on('click', function() {
        $('.overlay-menu').toggleClass('active');
        $(this).toggleClass('active');
        $('.navbar').toggleClass('menu-active')

    });

    let timeout = false;

    $(window).on('activate.bs.scrollspy', function (e,obj) {
        let newActiveId = obj.relatedTarget+'-fixed';

        clearTimeout(timeout);

        if (activeSectionId != newActiveId) {


            $('.home-section-fixed').not($(newActiveId)).css({'z-index':'1'});
            $(newActiveId).css({'z-index':'1'});

            $(newActiveId).fadeIn(300,function() {
            });

            timeout = setTimeout(function() {
                $('.home-section-fixed').not($(newActiveId)).fadeOut();
            },300);

            var navType = $(newActiveId).data('navtype');

            if (navType) {
                if (navType == 'none') {
                    $('.navbar').removeClass('active');
                } else {
                    $('.navbar').addClass('active');
                }
                $('.navbar').removeClass('light dark none darkSolid lightSolid').addClass(navType);
            }

            activeSectionId = newActiveId;
        }

        $('a[href^="#"]').on('click', function (e) {
            e.preventDefault();

            // Close menu
            $('.overlay-menu').removeClass('active');
            $('#menuToggle').removeClass('active');
            $('.navbar').removeClass('menu-active');

            var target = this.hash,
                $target = $(target);

            $('html, body').stop().animate({
                'scrollTop': $target.offset().top
            }, 900, 'swing', function () {
                window.location.hash = target;
            });
        });

    })
}

AOS.init({
    //once: true,
    //mirror: true,
    disable: 'mobile'
});